<script setup lang="ts">
import { computed } from 'vue';
import { InputGroup, Typography } from '@apparatix/library/core';
import DetailEditorBase from './DetailEditorBase.vue';
import type { AccountNoteErrors } from '@apparatix/schemas/AccountNotes';
import { useAccountStore } from '@apparatix/stores/useAccountStore';

type Props = {
  noHeadingLabels?: boolean;
  errors?: AccountNoteErrors;
}

const props = defineProps<Props>();
const store = useAccountStore();

const leftColLabel = computed(() => {
  if (props.noHeadingLabels) return undefined;
  return 'Account Notes';
});

const rightColLabel = computed(() =>
  'A/R',
);

</script>
<template>
  <DetailEditorBase :left-col-header="leftColLabel" :right-col-header="rightColLabel">
    <template #left-col>
      <InputGroup>
        <Typography v-show="Boolean(store.accountDetails.accountNotes)" variant="form-label">
          {{ store.accountDetails.accountNotes }}
        </Typography>
        <Typography v-show="!Boolean(store.accountDetails.accountNotes)" muted variant="form-label">
          Empty
        </Typography>
      </InputGroup>
    </template>
    <template v-if="true" #right-col>
      <InputGroup>
        <Typography v-show="Boolean(store.accountOverview.arNotes)" variant="form-label">
          {{ store.accountOverview.arNotes }}
        </Typography>
        <Typography v-show="!Boolean(store.accountOverview.arNotes)" muted variant="form-label">
          Empty
        </Typography>
      </InputGroup>
    </template>
  </DetailEditorBase>
</template>
